import React from 'react';

const breadcrumbItems = [
   { label: 'Home', href: '/' },
   { label: 'All courses', href: 'courses-list' },
   { label: 'User Experience Design', href: '#' },
   { label: 'User Interface', href: '#' }
];

const Breadcrumbs = () => {

   return (
      <section className="py-4 bg-gray-100 dark:bg-dark-5">
         <div className="container mx-auto px-4">
            <div className="flex flex-wrap">
               <div className="w-auto">
                  <div className="flex flex-wrap items-center">
                     {breadcrumbItems.map((item, index) => (
                        <div key={index} className="flex items-center">
                           <a
                              href={item.href}
                              className={`text-xs ${index === breadcrumbItems.length - 1 ? 'text-gray-700 dark:text-white font-medium' :
                                 'text-gray-400 hover:text-dark-1'}`}
                           >
                              {item.label}
                           </a>
                           {index < breadcrumbItems.length - 1 && (
                              <span className="mx-2 text-xs text-gray-400">/</span>
                           )}
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default Breadcrumbs;